import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { Home, CalendarDays, Wallet, CheckCircle2, MessageCircle, CalendarHeart, LogOut } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import ThemeToggle from '../../components/ThemeToggle';
import HalloweenToggle from '../../components/HalloweenToggle';
import logo from '../../assets/logo-badge.webp';

const TABS = [
  { to: '/', label: 'Inicio', icon: Home, end: true },
  { to: '/mis-clases', label: 'Clases', icon: CalendarDays },
  { to: '/mis-eventos', label: 'Eventos', icon: CalendarHeart },
  { to: '/mis-pagos', label: 'Pagos', icon: Wallet },
  { to: '/mi-asistencia', label: 'Asistencia', icon: CheckCircle2 },
  { to: '/mis-mensajes', label: 'Mensajes', icon: MessageCircle },
];

export default function StudentLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  async function doLogout() { await logout(); navigate('/login'); }

  const itemCls = ({ isActive }: { isActive: boolean }) =>
    `flex flex-1 flex-col items-center gap-0.5 rounded-lg py-1.5 text-[11px] font-medium transition sm:flex-none sm:flex-row sm:gap-1.5 sm:px-3 sm:py-2 sm:text-sm ${
      isActive ? 'text-brand-blue sm:bg-accent/10' : 'text-content-3 hover:text-content-2'}`;

  return (
    <div className="flex min-h-full flex-col bg-canvas">
      {/* Topbar */}
      <header className="sticky top-0 z-20 border-b border-line bg-surface/95 backdrop-blur">
        <div className="mx-auto flex max-w-2xl items-center justify-between px-4 py-3">
          <div className="flex items-center gap-2">
            <img src={logo} alt="Let's Move" className="h-8 w-8 rounded-full bg-white object-contain ring-1 ring-accent/40" />
            <span className="font-display text-base font-bold text-content">Let's Move</span>
          </div>
          <div className="flex items-center gap-1">
            <HalloweenToggle />
            <ThemeToggle />
            <button onClick={doLogout} className="rounded-lg p-2 text-content-3 transition hover:bg-surface-2 hover:text-content" title="Salir" aria-label="Salir">
              <LogOut size={18} />
            </button>
          </div>
        </div>
        {/* Tabs (escritorio) */}
        <nav className="mx-auto hidden max-w-2xl gap-1 px-4 pb-2 sm:flex">
          {TABS.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} className={itemCls}>
              <Icon size={16} /> {label}
            </NavLink>
          ))}
        </nav>
      </header>

      {/* Contenido */}
      <main className="mx-auto w-full max-w-2xl flex-1 px-4 py-5 pb-[calc(5rem+env(safe-area-inset-bottom))] sm:pb-5">
        <Outlet />
      </main>

      {/* Bottom-nav (móvil) */}
      <nav className="fixed inset-x-0 bottom-0 z-20 flex border-t border-line bg-surface px-2 py-1 pb-[calc(0.25rem+env(safe-area-inset-bottom))] sm:hidden">
        {TABS.map(({ to, label, icon: Icon, end }) => (
          <NavLink key={to} to={to} end={end} className={itemCls}>
            <Icon size={18} /> {label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
